import React from "react";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import FormItem from "../../../../components/FormItem/FormItem";
import IconButton from "../../../../components/IconButton/IconButton";
import Input from "../../../../components/Input/Input";
import Delete24 from "../../../../icons/Delete24";
import styles from "./additional-field.scss";

export default function AdditionalField(props) {
    const { label, onDelete, fieldId, onChangeLabel } = props;
    const [required, setRequired] = React.useState(false);

    function handleChangeLabel(e) {
        if (typeof onChangeLabel === "function") {
            onChangeLabel(e, fieldId);
        }
    }

    function handleDelete() {
        if (typeof onDelete === "function") {
            onDelete(fieldId);
        }
    }

    return (
        <div className={styles.wrapper}>
            <FormItem style={{ paddingBottom: 0 }} label={"Название поля"} error={label?.error || null} required={true}>
                <div className={styles.fieldName}>
                    <Input type="text" name="field-name" value={label?.value || ""} onChange={handleChangeLabel} placeholder={"Название"} />
                    <div className={styles.icon}>
                        <IconButton icon={<Delete24 />} onClick={handleDelete} />
                    </div>
                </div>
            </FormItem>
            {/* <Checkbox>Обязательное поле</Checkbox> */}
        </div>
    )
};